const config = {
  apiBaseUrl: process.env.VUE_APP_API_ORIGIN,
  clientId: process.env.VUE_APP_CLIENT_ID,
  clientSecret: process.env.VUE_APP_CLIENT_SECRET,
  alibabaCloudAppcode: process.env.VUE_APP_AC_APPCODE,
  menuStatus: {
    draft: 1, // 下書き
    inOperation: 2, // 運用中
  },

  // 注文時レコメンドのレコメンド登録できる最大数
  maxRecommendMenu: 10,
}

export default config
